import { render, staticRenderFns } from "./accordion-block.vue?vue&type=template&id=639b8d8a&scoped=true"
import script from "./accordion-block.vue?vue&type=script&lang=js"
export * from "./accordion-block.vue?vue&type=script&lang=js"
import style0 from "./accordion-block.vue?vue&type=style&index=0&id=639b8d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b8d8a",
  null
  
)

export default component.exports